// extracted by mini-css-extract-plugin
export default {"contents":"WH-z","sectionHeading":"XH-z"};